// src/pages/Register.tsx
import React, { useState } from 'react';
import { api } from '../lib/api';
import { Link } from 'react-router-dom';

const Register: React.FC = () => {
  const [username, setUsername] = useState('');
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);
  const [msg,      setMsg]      = useState<string | null>(null);
  const [err,      setErr]      = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null); setMsg(null);
    if (!username || !email || !password) {
      setErr('Please fill all fields'); return;
    }
    setLoading(true);
    try {
      const res = await api.post('/user/register', { username, email, password });
      setMsg(res.data?.message || 'Registered. Please verify your email to login.');
      setUsername(''); setEmail(''); setPassword('');
    } catch (e: any) {
      setErr(e?.response?.data?.error || e?.message || 'Signup failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <form onSubmit={submit} className="bg-white w-full max-w-md rounded-xl shadow p-8">
        <h1 className="text-2xl font-semibold mb-6 text-center">Create account</h1>
        <label className="block text-sm mb-1">Username</label>
        <input className="w-full mb-4 px-3 py-2 border rounded" value={username} onChange={e=>setUsername(e.target.value)} />
        <label className="block text-sm mb-1">Email</label>
        <input type="email" className="w-full mb-4 px-3 py-2 border rounded" value={email} onChange={e=>setEmail(e.target.value)} />
        <label className="block text-sm mb-1">Password</label>
        <input type="password" className="w-full mb-6 px-3 py-2 border rounded" value={password} onChange={e=>setPassword(e.target.value)} />
        <button disabled={loading} className="w-full bg-blue-600 text-white py-2 rounded">
          {loading ? 'Creating…' : 'Sign up'}
        </button>
        {msg && <div className="mt-4 text-green-600 text-sm">{msg}</div>}
        {err && <div className="mt-4 text-red-600 text-sm">{err}</div>}
        <div className="mt-6 text-center text-sm">
          Already have an account? <Link to="/login" className="text-blue-600">Log in</Link>
        </div>
      </form>
    </div>
  );
};
export default Register;
